import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import '../../stylesheet/navbar.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import evr from '../../assets/evr.gif';
import { useSelector, useDispatch } from 'react-redux';
import { setUpLocation } from '../../features/locationSlice';

export default function Naavbar() {
  const location = useSelector((state) => state.location.value);
  const dispatch = useDispatch();
  const [NavData, setNavData] = useState(false)

  useEffect(() => {
    if ((location === 'Las Vegas') || (location === 'Houston')) {
        setNavData(true)
    }else{
        setNavData(false)
    }
  }, [location])

  return (
    <div>
      <Navbar variant="dark" expand="lg" style={{ backgroundColor: '#272a3d' }}>
        <Container fluid>
          <Navbar.Brand href="/">
            <img src={evr} style={{ width: '50px', height: '50px' }} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-dark-example" />
          <Navbar.Collapse className="justify-content-end">
            <div>
              <input
                placeholder="Search Movies"
                style={{
                  padding: '5px',
                  borderRadius: '5px',
                  border: 'none',
                  marginRight: '10px',
                  width: '600px',
                  color: 'white',
                }}
              />
            </div>
            <Nav style={{ marginRight: '20px' }}>
              <NavDropdown title={location} className="nav-dropdown-title">
                <NavDropdown.Item
                  href="#action/3.2"
                  onClick={() => dispatch(setUpLocation(NavData ? 'New York' : 'Las Vegas'))}
                >
                  {NavData ? 'New York' : 'Las Vegas'}
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="#action/3.3"
                  onClick={() => dispatch(setUpLocation("Houston"))}
                >
                  Houston
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">Find More</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Outlet />
    </div>
  );
}
